import RouterView from '@/page/main/DefaultRouterView'


import Index from '@/page/m/index'
import MeetingList from '@/page/m/meetinglist'
import ApprovalList from '@/page/m/approvallist'
import ApprovalInfo from '@/page/m/approvalInfo'
import ProjectList from '@/page/m/projectlist'
import ContractList from '@/page/m/contractlist'

import MeetingUsers from '@/page/m/meetingusers'
import assetDetail from '@/page/m/assetDetail'

import notice from '@/page/m/notice'


import vacationInfo from '@/page/m/vacation/info'
import vacationList from '@/page/m/vacation/list'

export default {
  path: '/m',
  component: RouterView,
  children: [{
    path: 'Personnel/Vacation/Apply',
    meta: {
      type: ['user', 'vacationInfo'],
      title: "请假申请"
    },
    component: vacationInfo
  }, {
    path: 'Personnel/Vacation/List',
    meta: {
      type: ['user', 'vacationList'],
      title: "我的请假"
    },
    component: vacationList
  }, {
    path: '',
    meta: {
      type: ['index', ''],
      title: '象山水务集团 - 内部管理系统'
    },
    component: Index
  }, {
    path: 'Meeting/List',
    meta: {
      type: ['user', 'meetinglist'],
      title: "我的会议"
    },
    component: MeetingList
  }, {
    path: 'Notice/List',
    meta: {
      type: ['user', 'notice'],
      title: "我的通知公告"
    },
    component: notice
  }, {
    path: 'Project/List',
    meta: {
      type: ['user', 'ProjectList'],
      title: "我的工程"
    },
    component: ProjectList
  }, {
    path: 'Contract/List',
    meta: {
      type: ['user', 'ContractList'],
      title: "我的工程"
    },
    component: ContractList
  }, {
    path: 'Approval/List',
    meta: {
      type: ['user', 'ApprovalProjectList'],
      title: "我的审批"
    },
    component: ApprovalList
  }, {
    path: 'Approval/Info/:applyId/:tableType',
    meta: {
      type: ['user', 'ApprovalProjectList'],
      title: "审批详情"
    },
    component: ApprovalInfo
  }, {
    path: 'meetingusers/:mid',
    meta: {
      type: ['user', 'meetingusers'],
      title: "确认参会人员"
    },
    component: MeetingUsers
  }, {
    path: 'a/d/:id',
    meta: {
      type: ['user', 'assetDetail'],
      title: "固定资产详情"
    },
    component: assetDetail
  }]
}


// WEBPACK FOOTER //
// ./src/router/mobile.js